+function($) {
/**
 * Scroll to element.
 *
 * @function autoScroll
 * @param {HTMLElement} element - Element to scroll to.
 * @param {number} speed - Scrolling speed.
 * @param {number} offset - Offset from element.
 * @returns {void}
 */
function autoScroll(element, speed, offset) {
    if (!element || !element.length) {
        return;
    }

    var $parent = $('html, body');
    var navHeight = 10;
    var newLocation = element.offset().top;
    var currentLocation = window.pageYOffset;
    var toTravel = (currentLocation < newLocation) ? (currentLocation - newLocation) * -1 : ((currentLocation - newLocation) + offset) * -1;

    if (element.closest('.modal-container').length > 0) {
        $parent = element.closest('.modal-container');
    }

    $parent.stop().animate({
        scrollTop: (currentLocation + toTravel) - offset - navHeight
    }, speed, 'swing');
};
window.autoScroll = autoScroll;

/**
 * Bind click event to [data-autoscroll] elements
 * @fires autoScroll
 */
$(function() {
    $(document).on('click', '[data-autoscroll]', function(event) {
        event.preventDefault();
        var self = $(this);
        var target = self.attr('href');
        var speed = self.data('speed') || 500;
        var offset = self.data('offset') || 50;

        if (!target) {
            target = self.attr('data-autoscroll');
        }

        autoScroll($(target), speed, offset);
    });

    //call with url "scroll" parameter
    var params = window.location.search.substring(1);
    // if no parameters, return
    if (params.length == 0 ) return;

    params = params.split("&");
    for (var i = 0; i < params.length; i++) {
        var tmp = params[i].split("=");
        if(tmp[0] === "scroll"){
            autoScroll( $("#"+tmp[1]), 500, 0);
        }
    }
});

}(jQuery);
